import { useState } from "react";
import { CardGroupPackage } from "../../interfaces/scrollableCardGroup/ScrollableCardGroup.type";
import ScrollableCardGroupType from "./ScrollableCardGroup";
import styles from "./ScrollableCardGroup.module.css";
import useAppStore from "../../store/AppStore";

export default function ScrollableCardGroupContainer({
  items,
  scroll,
}: {
  items: CardGroupPackage[];
  scroll?: Boolean;
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const { isDeviceMobile } = useAppStore();
  return (
    <>
      {scroll ? (
        <div
          className={`vas-d-flex ${
            isDeviceMobile ? "" : "vas-mb-3"
          } vas-w-100 vas-card ${styles.card_holder}`}
        >
          {items?.map((data: CardGroupPackage, idx: number) => {
            return (
              <ScrollableCardGroupType
                data={data}
                setIsDisabled={setIsDisabled}
                isDisabled={isDisabled}
                key={idx}
                scroll={scroll}
              />
            );
          })}
        </div>
      ) : (
        <div className="vas-d-flex vas-justify-content-center">
          {items?.map((data: CardGroupPackage, idx: number) => {
            return (
              <ScrollableCardGroupType
                data={data}
                setIsDisabled={setIsDisabled}
                isDisabled={isDisabled}
                key={idx}
                scroll={scroll}
              />
            );
          })}
        </div>
      )}
    </>
  );
}
